<app-root-nav>
  <router-outlet></router-outlet>
</app-root-nav>